/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Broad_Red_Meerkat_IntendInputs */

const fr_broad_red_meerkat_intend = /** @type {(inputs: Broad_Red_Meerkat_IntendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher sur le site vitrine`)
};

/**

* @param {Broad_Red_Meerkat_IntendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const broad_red_meerkat_intend = /** @type {((inputs?: Broad_Red_Meerkat_IntendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Broad_Red_Meerkat_IntendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_broad_red_meerkat_intend(inputs)
});